import React from 'react'
import styled from 'styled-components'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import app from '../Firebase';
import { GithubAuthProvider, 
         getAuth, 
         signOut } 
from "firebase/auth";
import { useHistory } from 'react-router-dom'
import { setSignOut, 
         } 
from '../features/user/UserSlice'
import { useDispatch } from 'react-redux'
import Cards from '../components/Cards';
import HomeNav from '../components/HomeNav';


function Home() {

    const dispatch = useDispatch()

    const auth = getAuth(app);
    const history = useHistory()

    const logOut = ()=>{
        signOut(auth).then(() => {
            dispatch(setSignOut())
            history.push('/')
            // Sign-out successful.
          }).catch((error) => {
              alert(error)
            // An error happened.
          });
    }


    return (
        <Container>
            <Navbar button='Sign Out' clickEvent={logOut}/>
            <HomeNav/>

         <Content>   
                        <Cards
                            head='E-commerce product page'
                            points = '3'
                            level='intermediate'
                            html='html'
                            css = 'css'
                            js = 'js'
                            detail={`In this challenge, you'll build a beautiful 
                                    product page. We'll be putting your JS skills to 
                                    the test with a lightbox product gallery and cart
                                    functionality!`} 
                            image='/images/grid1.jpg'
                            />
                        <Cards
                            head='Memory game'
                            points = '4'
                            level='advanced'
                            html='html'
                            css = 'css'
                            js = 'js'
                            detail={`This project will be an excellent test for 
                                     your HTML, CSS, and JS skills! You'll be 
                                     building a fun memory game where players try to match pairs.`} 
                            image='/images/grid2.jpg'
                            />
                        <Cards
                            head='Time tracking dashboard'
                            points = '2'
                            level='juniour'
                            html='html'
                            css = 'css'
                            js = 'js'
                            detail={`A perfect opportunity to practice your CSS Grid skills. 
                                    For anyone wanting to take it up a notch, we provide a 
                                    JSON data file to practice working with data.`} 
                            image='/images/grid3.jpg'
                            />
                       
                   
                            <Cards
                                head='GitHub user search app'
                                points = '2'
                                level='juniour'
                                html='html'
                                css = 'css'
                                js = 'js'
                                api = 'api'
                                detail={`In this project, you'll use the GitHub users API 
                                        to pull profile data and display it. It's a great challenge 
                                        if you're looking to practice working with a 3rd-party API.`} 
                                image='/images/grid4.jpg'
                                />
                            <Cards
                                head='Order summary component'
                                points = '1'
                                level='newbie'
                                html='html'
                                css = 'css'
                                detail={`A perfect project for newbies who are starting to build confidence with layouts!`} 
                                image='/images/grid5.jpg'
                                />
                            <Cards
                                head='Galleria slideshow site'
                                points = '3'
                                level='intermediate'
                                html='html'
                                css = 'css'
                                js = 'js'
                                detail={`This art gallery slideshow project will be a great test for your layout 
                                and JS skills. With the masonry layout, slideshow logic, and lightbox 
                                view there's a lot to build!`} 
                                image='/images/grid6.jpg'
                                />
                        <Cards
                            head='Space tourism multi-page website'
                            points = '3'
                            level='intermediate'
                            html='html'
                            css = 'css'
                            js = 'js'
                            detail={`This project is a fun collaboration with 
                                     Scrimba and Kevin Powell! If you like, 
                                     you can follow along and watch Kevin complete 
                                     the project on Scrimba. Lots to be learned!`} 
                            image='/images/grid7.jpg'
                            />
                        <Cards
                            head='Product feedback app'
                            points = '4'
                            level='advanced'
                            html='html'
                            css = 'css'
                            js = 'js'
                            detail={`This will be a perfect portfolio piece! 
                                     You'll be working with JSON, 
                                     managing state, and building like a real-world 
                                     app. You can even create it as a full-stack project!`} 
                            image='/images/grid8.jpg'
                            />
                        <Cards
                            head='Planets fact site'
                            points = '3'
                            level='intermediate'
                            html='html'
                            css = 'css'
                            js = 'js'
                            detail={`In this challenge, you'll be building 
                                     out an 8-page fact site 
                                    for all planets in our solar system. This project 
                                    will make an incredible portfolio piece when completed!`} 
                            image='/images/grid9.jpg'
                            />
                       
                   
                            <Cards
                                head='Sunnyside agency landing page'
                                points = '2'
                                level='juniour'
                                html='html'
                                css = 'css'
                                js = 'js'
                                api = 'api'
                                detail={`This challenge will be a perfect test of your 
                                        layout and responsive skills. There's a tiny bit 
                                        of JS for the mobile menu, but the focus is HTML & CSS.`} 
                                image='/images/grid10.jpg'
                                />
                            <Cards
                                head='Audiophile e-commerce website'
                                points = '5'
                                level='guru'
                                html='html'
                                css = 'css'
                                js = 'js'
                                detail={`This huge e-commerce challenge will provide an incredible 
                                        test for your front-end skills. Once you're 
                                        done, you'll have an amazing project to add to your portfolio!`} 
                                image='/images/grid11.jpg'
                                />
                            <Cards
                                head='Bloger landing page'
                                points = '2'
                                level='junior'
                                html='html'
                                css = 'css'
                                js = 'js'
                                detail={`Flex your layout muscles with this landing page challenge. 
                                        You'll mostly be working with HTML & CSS for this project 
                                        with a tiny bit of JS for the mobile menu.`} 
                                image='/images/grid12.jpg'
                                />
                       
        </Content>
            <Footer/>
        </Container>
    )
}

export default Home

const Container = styled.div`
   width: 100vw;
   height: 100vh;
   margin: auto;

`

const Content = styled.div`
display: grid;
grid-gap: 25px;
padding: 20px 30px;
margin: 2rem;
grid-template-columns: repeat(3, minmax(0, 1fr));

@media(max-width: 1350px){
    grid-template-columns: repeat(2, minmax(0, 1fr));

}

@media(max-width: 900px){
    grid-template-columns: repeat(1, minmax(0, 1fr));

}


`
